import type {
  IMapObjectsOptions,
  IMapClusterOptions,
  IMapBalloonOptions,
  IMapMarkerOptions,
} from "../types";
import {
  STYLE_CLUSTER_ICON,
  STYLE_BALLOON_CONTENT_TITLE,
  STYLE_BALLOON_CONTENT_DETAILS,
  STYLE_BALLOON_CONTENT_BUTTON,
} from "./style";
import { LABEL_SELECT_SHOP_ACTION } from "./labels";
import { ShopSelectShopType } from "../enums";
import WatchesIcon from "@magnit/icons/src/assets/icons/watches-16.svg?raw";
import PinMagnitIconRaw from "@magnit/icons/src/assets/icons/pin-magnit-40.svg?raw";
import PinCosmeticIconRaw from "@magnit/icons/src/assets/icons/pin-cosmetic-40.svg?raw";
import PinAptekaIconRaw from "@magnit/icons/src/assets/icons/pin-apteka-40.svg?raw";
import PinV1IconRaw from "@magnit/icons/src/assets/icons/pin-v1-40.svg?raw";
import LogoMagnitIconRaw from "@magnit/icons/src/assets/icons/logo-magnit-24-colored-bg-invert.svg?raw";
import LogoCosmeticIconRaw from "@magnit/icons/src/assets/icons/logo-cosmetic-24-colored-bg-invert.svg?raw";
import LogoAptekaIconRaw from "@magnit/icons/src/assets/icons/logo-apteka-24-colored-bg-invert.svg?raw";
import LogoV1IconRaw from "@magnit/icons/src/assets/icons/logo-v1-36-color.svg?raw";
import CloseIconRaw from "@magnit/icons/src/assets/icons/close-24.svg?raw";
import GeolocationIconRaw from "@magnit/icons/src/assets/icons/location-24.svg?raw";

export const MAP_DEFAULT_MAP_OBJECTS_OPTIONS: IMapObjectsOptions = {
  iconLayout: "default#imageWithContent",
  iconImageHref: "",
  defaultIcon: "",
  selectedIcon: "",
  iconContentSize: [40, 40],
  iconContentOffset: [-20, -40],
  iconContentLayout: `<div class="shop-select__map--pin{% if properties.xl %} shop-select__map--pin-xl{% endif %}">
      {% if properties.storeType === "${ShopSelectShopType.AtHouse}" %}
        ${PinMagnitIconRaw}
      {% elseif properties.storeType === "${ShopSelectShopType.Cosmetic}" %}
        ${PinCosmeticIconRaw}
      {% elseif properties.storeType === "${ShopSelectShopType.Pharmacy}" %}
        ${PinAptekaIconRaw}
      {% elseif properties.storeType === "${ShopSelectShopType.V1}" %}
        ${PinV1IconRaw}
      {% else %}
        ${PinMagnitIconRaw}
      {% endif %}
    </div>`,
};

export const MAP_DEFAULT_MAP_GEOLOCATION_OBJECT_OPTIONS: IMapObjectsOptions = {
  iconLayout: "default#imageWithContent",
  iconImageHref: "",
  defaultIcon: "",
  selectedIcon: "",
  iconContentSize: [24, 24],
  iconContentOffset: [-12, -12],
  iconContentLayout: `<div class="shop-select__map--pin">${GeolocationIconRaw}</div>`,
};

export const MAP_DEFAULT_MAP_CLUSTER_OPTIONS: IMapClusterOptions = {
  clusterIconLayout: `<div style="${STYLE_CLUSTER_ICON}" class="pl-text shop-select__map--cluster">{{ properties.geoObjects.length }}</div>`,
  type: "Circle",
  coordinates: [0, 0],
  radius: 46,
};

export const MAP_DEFAULT_MAP_CLUSTER_OPTIONS_V1: IMapClusterOptions = {
  clusterIconLayout: `<div style="${STYLE_CLUSTER_ICON}" class="pl-text shop-select__map--cluster v1">{{ properties.geoObjects.length }}</div>`,
  type: "Circle",
  coordinates: [0, 0],
  radius: 46,
};

export const MAP_DEFAULT_BALLOON_CONTENT_ICON = `
  <div class="shop-select__map__balloon-icon">
    {% if properties.storeType === "${ShopSelectShopType.AtHouse}" %}
      ${LogoMagnitIconRaw}
    {% elseif properties.storeType === "${ShopSelectShopType.Cosmetic}" %}
      ${LogoCosmeticIconRaw}
    {% elseif properties.storeType === "${ShopSelectShopType.Pharmacy}" %}
      ${LogoAptekaIconRaw}
    {% elseif properties.storeType === "${ShopSelectShopType.V1}" %}
      ${LogoV1IconRaw}
    {% else %}
      ${LogoMagnitIconRaw}
    {% endif %}
  </div>`;

export const MAP_DEFAULT_BALLOON_CONTENT_DETAILS = `
  <div class="shop-select__map__balloon-details">
    {% if properties.storeType !== "${ShopSelectShopType.V1}" %}
      <h4 class="pl-text" style="${STYLE_BALLOON_CONTENT_TITLE}">{{ properties.shopTitle }}</h4>
    {% endif %}
    <p class="pl-text" style="${STYLE_BALLOON_CONTENT_DETAILS}">{{ properties.address }}</p>
    <p class="pl-text shop-select__map__balloon-schedule" style="${STYLE_BALLOON_CONTENT_DETAILS}">
      <span class="shop-select__map__balloon-schedule-icon">${WatchesIcon}</span> 
      {{ properties.schedule }}
    </p>
  </div>`;

export const MAP_DEFAULT_BALLOON_CONTENT_ACTION = `
  {% if properties.displayAction %}
    <button data-id="$[properties.id]" class="pl-text shop-select__map__balloon__submit" style="${STYLE_BALLOON_CONTENT_BUTTON}">{{ properties.actionLabel }}</button>
  {% endif %}`;

export const MAP_DEFAULT_BALLOON_LAYOUT_HTML = `<div class="shop-select__map__balloon" data-id="$[properties.id]">
    <a class="shop-select__map__balloon__close" href="#">${CloseIconRaw}</a>$[[options.contentLayout]]
    <div class="shop-select__map__balloon--bottom">
      <div class="shop-select__map__balloon--bottom-arrow"></div>
      <div class="shop-select__map__balloon--bottom-shadow"></div>
    </div>
  </div>`;

export const MAP_BALLOON_CONTENT_ACTION = `
  <div class="shop-select__map__balloon-content__outer shop-select__map__balloon--{{ properties.storeType }}">
    <div class="shop-select__map__balloon-content">
      ${MAP_DEFAULT_BALLOON_CONTENT_ICON}
      ${MAP_DEFAULT_BALLOON_CONTENT_DETAILS}
    </div>
    ${MAP_DEFAULT_BALLOON_CONTENT_ACTION}
  </div>
`;

export const MAP_BALLOON_CONTENT_INFO = `
  <div class="shop-select__map__balloon-content__outer shop-select__map__balloon--{{ properties.storeType }}">
    <div class="shop-select__map__balloon-content">
      ${MAP_DEFAULT_BALLOON_CONTENT_ICON}
      ${MAP_DEFAULT_BALLOON_CONTENT_DETAILS}
    </div>
  </div>
`;

export const MAP_DEFAULT_BALLOON_SELECTOR = ".shop-select__map__balloon";
export const MAP_DEFAULT_BALLOON_SELECTOR_CLOSE = `${MAP_DEFAULT_BALLOON_SELECTOR}__close`;
export const MAP_DEFAULT_BALLOON_SELECTOR_SUBMIT = `${MAP_DEFAULT_BALLOON_SELECTOR}__submit`;

export const MAP_BALLOON_OPTIONS_ACTION: IMapBalloonOptions = {
  layoutHtml: MAP_DEFAULT_BALLOON_LAYOUT_HTML,
  balloonContentLayout: MAP_BALLOON_CONTENT_ACTION,
  balloonSelector: MAP_DEFAULT_BALLOON_SELECTOR,
  closeButtonSelector: MAP_DEFAULT_BALLOON_SELECTOR_CLOSE,
  submitButtonSelector: MAP_DEFAULT_BALLOON_SELECTOR_SUBMIT,
};

export const MAP_BALLOON_OPTIONS_INFO: IMapBalloonOptions = {
  layoutHtml: MAP_DEFAULT_BALLOON_LAYOUT_HTML,
  balloonContentLayout: MAP_BALLOON_CONTENT_INFO,
  balloonSelector: MAP_DEFAULT_BALLOON_SELECTOR,
  closeButtonSelector: MAP_DEFAULT_BALLOON_SELECTOR_CLOSE,
};

export const MAP_DEFAULT_BALLOON_OPTIONS = MAP_BALLOON_OPTIONS_ACTION;

export const MAP_DEFAULT_MARKER_OPTIONS: IMapMarkerOptions = {
  type: "Feature",
  geometryType: "Point",
  actionLabel: LABEL_SELECT_SHOP_ACTION,
  properties: {},
};

export const MAP_RENDER_TICK = 50;
export const MAP_GEOLOCATION_PIN_ID = "VShopSelect--geolocation-pin";
